import { render, staticRenderFns } from "./ReplacementZJEdit.vue?vue&type=template&id=6ab9a870&scoped=true&"
import script from "./ReplacementZJEdit.vue?vue&type=script&lang=js&"
export * from "./ReplacementZJEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab9a870",
  null
  
)

export default component.exports